import React from "react";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { IconButton, Stack, styled } from "@mui/material";

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.error.light,
    /*  color: theme.palette.error.main, */
    /*  maxWidth: 220, */
    fontSize: theme.typography.pxToRem(16),
    border: "1px solid #dadde9",
  },
}));

export const ErrorTooltip: React.FC<TooltipProps> = (
  props
): React.JSX.Element | null => {
  const [show, setShow] = React.useState(false);
  const { children, ...toolTipProps } = props;
  React.useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (props.title !== "") {
      setShow(true);
      timeout = setTimeout(() => {
        closeTooltip();
      }, 10000);
    }
    return () => clearTimeout(timeout);
  }, [props.title]);

  const closeTooltip = () => {
    setShow(false);
  };

  return (
    <CustomTooltip
      {...toolTipProps}
      open={show}
      title={
        <Stack direction="row" justifyContent="center" alignItems="center">
          {props.title}{" "}
          <IconButton onClick={closeTooltip}>
            <HighlightOffIcon />
          </IconButton>
        </Stack>
      }
    >
      <div>{children}</div>
    </CustomTooltip>
  );
};
